export const path = "/ready-leads-supply";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "READY LEADS SUPPLY",
  section: "HOP",
  group: null,
  order: 2,
  roles: [
    "Authenticated",
    "hop-management",
    "hop-publisher-partnerships",
  ],
};
